import { render } from "./Slider.vue?vue&type=template&id=8d0b7cfc&scoped=true&ts=true"
import script from "./Slider.ts?vue&type=script&lang=ts"
export * from "./Slider.ts?vue&type=script&lang=ts"

import "./Slider.scss?vue&type=style&index=0&id=8d0b7cfc&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0b7cfc"]])

export default __exports__